import { createFeatureSelector, createSelector } from '@ngrx/store';
import { scorecardFeatureKey, ScorecardState } from './scorecard.reducer';

export const selectScorecardState = createFeatureSelector<ScorecardState>(scorecardFeatureKey);

export const getCanAddAccountList = createSelector(selectScorecardState,
  (state: ScorecardState) => state.canAddList
);
